import { Controller } from 'stimulus'
import { differenceInMonths, differenceInYears } from 'date-fns'

export default class extends Controller {
  static get targets() {
    return ['text', 'input', 'birthDateInput']
  }

  updateBirthDate() {
    let text = this.textTarget
    let inputs = this.birthDateInputTarget
    let year = inputs.children[0].value
    let month = inputs.children[1].value
    let day = inputs.children[2].value

    if (year && month && day) {
      text.dataset.birthDate = `${year}-${month}-${day}`
      this.updateApproximateAge()
    }
  }

  updateApproximateAge() {
    let text = this.textTarget
    let defaultText = '（年月を入れると計算されます）'
    let birthDate = new Date(text.dataset.birthDate)
    let inputs = this.inputTarget
    let year = inputs.children[0].value
    let month = inputs.children[1].value

    if (year && month) {
      let date = new Date(year, month, 0)
      let yearDiff = differenceInYears(date, birthDate)
      let monthDiff = differenceInMonths(date, birthDate) % 12
      let newText = `およそ${yearDiff}歳`
      if (yearDiff < 7) {
        newText = newText + `${monthDiff}か月`
      }
      text.innerText = newText
    } else {
      if (text.innerText != defaultText) {
        text.innerText = defaultText
      }
    }
  }
}
